export const getDefaultState = () => ({
  reservations: []
})

const state = getDefaultState()

export default state
